import {
  Autocomplete,
  AutocompleteChangeReason,
  FormControl,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip
} from "@mui/material";
import Pagination from "base/ui/components/Pagination/pagination";
import { observer } from "mobx-react-lite";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { AiFillPrinter } from "react-icons/ai";
import { HiSearch } from "react-icons/hi";
import Moment from "react-moment";
import { Link, useNavigate } from "react-router-dom";
import {
  WorkOrderDetail,
  WorkOrderModel,
  dataPrint,
  saveBarcode,
} from "services/workOrder_services";
import * as rootStore from "stores/root_store";
import { URL_PRINT } from "utils/constants";

import LoadingScreen from "base/ui/components/LoadingScreen/loadingScreen";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { TbLoaderQuarter } from "react-icons/tb";
import { toast } from "react-toastify";
import { ListDate, ListStatusProduct } from "services/commonDate_services";
import { formatNumber } from "utils/formatHelper";
import { Button as CustomButton, message, Modal } from 'antd';
import ModalCreateDes from './ModalCreateDes';
import { getUserSession } from 'utils/localStorageHelper';
import { User } from 'services/user_services';



type saveBarcodeModel = {
  workOrderId?: string;
  printQuantity?: number;
  quantityByPallet: number;
};

export function createWorkOrder() {
  return observer(() => {
    // Tên trang
    document.title = "Lệnh sản xuất - iMES System";
    //===============================================
    const column = [
      {
        columnName: "STT",
        align: "text-center",
        visible: true,
        sticky: "sticky left-0 bg-primary z-10",
        key: "stt",
      },
      {
        columnName: "Chức năng",
        align: "text-center",
        visible: true,
        sticky: "sticky left-[45.2px] min-w-[250.11px]  bg-primary z-10",
      },

      {
        columnName: "Ưu tiên",
        align: "text-center",
        visible: false,
      },

      {
        columnName: "Lệnh sản xuất",
        align: "text-center",
        visible: true,
        sticky: "sticky left-[294.5px] bg-primary z-10",
        width: "min-w-[120px]",
        isSoft: true,
        key: "workOrderCode",
      },
      {
        columnName: "Khách hàng",
        align: "text-center",
        visible: true,
        width: "min-w-[100px]",
      },
      {
        columnName: "Loại LSX",
        align: "text-center",
        visible: true,
      },
      {
        columnName: "Mã LSX tổng hợp",
        align: "text-center",
        visible: true,
        width: "min-w-[120px]",
        isSoft: true,
        key: "parentWorkOrderCode",
      },
      {
        columnName: "Lệnh ghép bài/Phiếu thiết kế",
        align: "text-center",
        visible: true,
        width: "min-w-[120px]",
        key: "matchCard",
      },
      { columnName: "Mã TP/BTP", align: "text-center", visible: true },
      { columnName: "Tên TP/BTP", align: "text-center", visible: true },
      { columnName: "BOM vesion", align: "text-center", visible: true },
      {
        columnName: "Số lượng phát lệnh",
        align: "text-center",
        visible: true,
        width: "min-w-[120px]",
        isSoft: true,
        key: "quantity",
      },
      {
        columnName: "Đơn vị tính",
        align: "text-center",
        visible: true,
        width: "min-w-[120px]",
      },
      {
        columnName: "Ngày ban hành LSX",
        align: "text-center",
        visible: true,
        width: "min-w-[120px]",
      },
      {
        columnName: "Ngày bắt đầu SX dự kiến",
        align: "text-center",
        visible: true,
        width: "min-w-[120px]",
      },
      {
        columnName: "Ngày kết thúc SX dự kiến",
        align: "text-center",
        visible: true,
        width: "min-w-[120px]",
      },
      {
        columnName: "Ngày bắt đầu SX thực tế",
        align: "text-center",
        visible: true,
        width: "min-w-[120px]",
      },
      {
        columnName: "Ngày kết thúc SX thực tế",
        align: "text-center",
        visible: true,
        width: "min-w-[120px]",
      },

      {
        columnName: "Hạng mục in",
        align: "text-center",
        visible: true,
        width: "min-w-[100px]",
      },
      {
        columnName: "Tên routing",
        align: "text-center",
        visible: true,
      },

      {
        columnName: "Kiểu in",
        align: "text-center",
        visible: true,
        width: "min-w-[80px]",
      },
      {
        columnName: "Ngày yêu cầu hàng in về",
        align: "text-center",
        visible: true,
        width: "min-w-[120px]",
      },
      {
        columnName: "Ngày yêu cầu nhập kho",
        align: "text-center",
        visible: true,
        width: "min-w-[120px]",
      },
      {
        columnName: "Công ty gia công in",
        align: "text-center",
        visible: true,
        width: "min-w-[100px]",
      },
      {
        columnName: "ĐV gia công thành phẩm",
        align: "text-center",
        visible: true,
        width: "min-w-[100px]",
      },
      {
        columnName: "Ghi chú sản xuất",
        align: "text-center",
        visible: true,
        width: "min-w-[120px] ",
      },
      {
        columnName: "Tình trạng sản phẩm",
        align: "text-center",
        visible: true,
        width: "min-w-[100px]",
      },
      {
        columnName: "Số PO/Hợp đồng/Báo giá",
        align: "text-center",
        visible: true,
        width: "min-w-[120px]",
      },
      { columnName: "Khuôn", align: "text-center", visible: true },
      {
        columnName: "Trạng thái Netsuite",
        align: "text-center",
        visible: true,
      },
      { columnName: "Trạng thái MES", align: "text-center", visible: true },
    ];

    const Style = {
      MuiTableCellRoot: {
        fontSize: "13px",
        fontWeight: 700,
        padding: "5px 10px",
        lineHeight: "20px",
        color: "white",
      },
      borderInherit: {
        borderCollapse: "inherit",
      },
      MuiButtonBaseRoot: {
        color: "white !important",
      },
      MuiTableCellRootTd: {
        fontSize: "13px",
        padding: "5px",
        lineHeight: "20px",
        borderBottom: "unset",
      },
      sticky1: {
        position: "sticky",
        left: 0,
        background: "white",
        zIndex: 5,
      },
      sticky2: {
        position: "sticky",
        left: 45.2,
        background: "white",
        zIndex: 5,
      },
      sticky3: {
        position: "sticky",
        left: 294.5,
        background: "white",
        zIndex: 5,
        color: "#0284c7",
      },

      ".MuiOutlinedInput-root": {
        padding: 0,
      },
      ".MuiOutlinedInput-input": {
        fontSize: "13px",
      },
      ".MuiOutlinedInput-notchedOutline": { borderRadius: 0 },
    };

    const navigate = useNavigate();

    const ref = useRef<HTMLFormElement>(null);

    const { register, handleSubmit } = useForm<WorkOrderDetail>();
    const {
      register: registerForm2,
      handleSubmit: handleSubmitBarcode,
      formState: { errors },
    } = useForm<saveBarcodeModel>();
    // =================== ===================================//
    //                      SET STATE                         //
    //========================================================//


    // -----DATA SEARCH --------------------------------
    // lưu date search vô 1 state
    // const [dataSearch, setDataSearch] = useState(rootStore.workOrderStore.workOrderSearch);

    // save id work order
    const [WorkOrderId, setWorkOrderId] = useState("");

    //-----------------------------XXX-------------------------------------------------------------------------------------
    //------COMMON------------------------------------------------------------------------------------------------
    // list date
    const [listDate, setlistDate] = useState<ListDate[]>([]);
    // list Trạng thái MES
    const [mesStatus, setMesStatus] = useState<ListStatusProduct[]>([]);
    //Trạng thái Netsuite
    const [netsuiteStatus, setNetsuiteStatus] = useState<ListStatusProduct[]>(
      []
    );
    //-----------------------------XXX------------------------------------------------------------------------------------
    // custom option of Mes Status
    const optionMes = mesStatus; //nếu có thay đổi gì thì custom lại option

    //set dong mo modal
    const [open, setOpen] = useState(false);

    const [valuePrintQuantity, setValuePrintQuantity] = useState("");

    //
    const [transferData, setTransferData] = useState<dataPrint | undefined>({
      batchId: "",
      workOrderCardIds: [],
    });

    // set data the treo pallet
    const [infoBarcode, setInfoBarcode] = useState<saveBarcode>({
      workOderCode: "",
      productName: "",
      quantityPrinted: 0,
      quantity: 0,
    });

    // Loading của cả trang nếu gửi api thì cho loading
    const [loading, setLoading] = useState(false);
    // search loading // dùng để loading lúc search
    // phần loading này chỉ dùng cho search
    const [isReady, setIsReady] = useState(false);

    // các row trong table lấy từ store
    const [listWorkOrder, setListWorkOrder] = useState<WorkOrderModel[]>([]);
    // const tableRows = rootStore.workOrderStore.workOrder.data;

    // autocomplete tp/btp
    const [dropdownProduct, setDropdownProduct] = useState<ListStatusProduct[]>(
      []
    );

    //===================== XXX ================XXX ================XXX ================

    // ===================================================================================//
    //                                LOAD DỮ LIỆU                                        //
    // ===================================================================================//
    // Lấy dropdown products
    const getDropdownProduct = async (keyword = "") => {
      await rootStore.commonDatePresenter.getListDropdownProduct(
        rootStore.commonDateStore,
        keyword
      );
      setDropdownProduct(rootStore.commonDateStore.listDropdownProduct);
    };

    // Hàm lấy dropdown trạng thái MES
    const getListDropDownMesStatus = async (
      keywword = "WorkOrderStatusMes"
    ) => {
      await rootStore.commonDatePresenter.getDropdownByKeyword(
        rootStore.commonDateStore,
        keywword
      );
      setMesStatus(rootStore.commonDateStore.dropdownByKey);
    };
    // Hàm lấy dropdown Trạng thái Netsuite

    const getListDropDownNetsuiteStatus = async (
      keywword = "WorkOrderStatus"
    ) => {
      await rootStore.commonDatePresenter.getDropdownByKeyword(
        rootStore.commonDateStore,
        keywword
      );
      setNetsuiteStatus(rootStore.commonDateStore.dropdownByKey);
    };

    const getListDate = async () => {
      await rootStore.commonDatePresenter.getListCommonDate(
        rootStore.commonDateStore
      );
      setlistDate(rootStore.commonDateStore.listDate.data);
    };

    // lấy data tabel
    const getListWorkOrder = async (
      data = rootStore.workOrderStore.workOrderSearch
    ) => {
      await rootStore.workOrderPresenter.getListWorkOrder(
        rootStore.workOrderStore,
        data
      );
      if (rootStore.workOrderStore.workOrder.isSuccess) {
        setListWorkOrder(rootStore.workOrderStore.workOrder.data);
      }
    };

    // lấy ngày sản xuất dư kiến bằng key common date
    const getEstimateFromDate = async (key: string) => {
      if (key) {
        await rootStore.commonDatePresenter.getDataByCommonDate(
          rootStore.commonDateStore,
          key
        );

        rootStore.workOrderPresenter.setStateSearch(rootStore.workOrderStore, {
          ...rootStore.workOrderStore.workOrderSearch,
          estimateFromDateFrom: rootStore.commonDateStore.commonDate.fromDate
            ? rootStore.commonDateStore.commonDate.fromDate
            : undefined,
          estimateFromDateTo: rootStore.commonDateStore.commonDate.toDate
            ? rootStore.commonDateStore.commonDate.toDate
            : undefined,
          estimateDate: key,
        });
      } else {
        rootStore.workOrderPresenter.setStateSearch(rootStore.workOrderStore, {
          ...rootStore.workOrderStore.workOrderSearch,
          estimateFromDateFrom: undefined,
          estimateFromDateTo: undefined,
          estimateDate: key,
        });
      }
    };
    // lấy ngày phát lệnh bằng key common date
    const getDocumentDate = async (key: string) => {
      if (key) {
        await rootStore.commonDatePresenter.getDataByCommonDate(
          rootStore.commonDateStore,
          key
        );
        rootStore.workOrderPresenter.setStateSearch(rootStore.workOrderStore, {
          ...rootStore.workOrderStore.workOrderSearch,
          documentDateFrom: rootStore.commonDateStore.commonDate.fromDate
            ? rootStore.commonDateStore.commonDate.fromDate
            : undefined,
          documentDateTo: rootStore.commonDateStore.commonDate.toDate
            ? rootStore.commonDateStore.commonDate.toDate
            : undefined,
          documentDate: key,
        });
      } else {
        rootStore.workOrderPresenter.setStateSearch(rootStore.workOrderStore, {
          ...rootStore.workOrderStore.workOrderSearch,
          documentDateFrom: undefined,
          documentDateTo: undefined,
          documentDate: key,
        });
      }
    };

    //===================== XXX ================XXX ================XXX ================

    // ===================================================================================//
    //                                USEEFECT                                            //
    // ===================================================================================//
    // khởi tạo trang
    useEffect(() => {
      const getData = async () => {

        pagePermissions();


        await getListDate();
        await getDocumentDate(
          rootStore.workOrderStore.workOrderSearch.documentDate || ""
        );

        await getDropdownProduct(
          rootStore.workOrderStore.workOrderSearch.productCode
        );
        await getListWorkOrder(rootStore.workOrderStore.workOrderSearch);
        // gọi api dropdown trạng thái MES
        await getListDropDownMesStatus();
        await getListDropDownNetsuiteStatus();
        setIsReady(true);
      };
      getData();
    }, []);

    //===================== XXX ================XXX ================XXX ================

    // ===============================================================//
    //                        FUNCTION                                //
    //================================================================//

    const handleSortRequest = async (key: string) => {
      setLoading(true);
      if (
        !rootStore.workOrderStore.workOrderSearch.paging.orderBy &&
        !rootStore.workOrderStore.workOrderSearch.paging.orderByDesc
      ) {
        rootStore.workOrderPresenter.setStateSearch(rootStore.workOrderStore, {
          ...rootStore.workOrderStore.workOrderSearch,
          paging: {
            ...rootStore.workOrderStore.workOrderSearch.paging,
            orderBy: key,
            orderByDesc: undefined,
          },
        });
      } else if (
        rootStore.workOrderStore.workOrderSearch.paging.orderBy === key
      ) {
        rootStore.workOrderPresenter.setStateSearch(rootStore.workOrderStore, {
          ...rootStore.workOrderStore.workOrderSearch,
          paging: {
            ...rootStore.workOrderStore.workOrderSearch.paging,
            orderBy: undefined,
            orderByDesc: key,
          },
        });
      } else if (
        rootStore.workOrderStore.workOrderSearch.paging.orderByDesc === key
      ) {
        rootStore.workOrderPresenter.setStateSearch(rootStore.workOrderStore, {
          ...rootStore.workOrderStore.workOrderSearch,
          paging: {
            ...rootStore.workOrderStore.workOrderSearch.paging,
            orderBy: undefined,
            orderByDesc: undefined,
          },
        });
      } else {
        rootStore.workOrderPresenter.setStateSearch(rootStore.workOrderStore, {
          ...rootStore.workOrderStore.workOrderSearch,
          paging: {
            ...rootStore.workOrderStore.workOrderSearch.paging,
            orderBy: key,
            orderByDesc: undefined,
          },
        });
      }
      await getListWorkOrder(rootStore.workOrderStore.workOrderSearch);
      setLoading(false);
    };
    //--------XỬ LÝ PHÂN TRANG ----------------------------------------------------------------------
    const handleChangePageIndex = async (data: any) => {
      setLoading(true);
      // setPageIndex(data.selected + 1);
      await rootStore.workOrderPresenter.setStateSearch(
        rootStore.workOrderStore,
        {
          ...rootStore.workOrderStore.workOrderSearch,
          paging: {
            ...rootStore.workOrderStore.workOrderSearch.paging,
            pageIndex: data.selected + 1,
          },
        }
      );
      // lấy danh sách lệnh sản xuất theo paging
      await getListWorkOrder({
        ...rootStore.workOrderStore.workOrderSearch,
        paging: {
          ...rootStore.workOrderStore.workOrderSearch.paging,
          pageIndex: data.selected + 1,
        },
      });
      setLoading(false);
    };

    const handleChangePageSize = async (
      e: React.ChangeEvent<HTMLSelectElement>
    ) => {
      setLoading(true);
      // setPageSize(parseInt(e.target.value));
      await rootStore.workOrderPresenter.setStateSearch(
        rootStore.workOrderStore,
        {
          ...rootStore.workOrderStore.workOrderSearch,
          paging: {
            ...rootStore.workOrderStore.workOrderSearch.paging,
            pageSize: parseInt(e.target.value),
            pageIndex: 1,
          },
        }
      );
      // lấy danh sách lệnh sản xuất theo paging
      await getListWorkOrder({
        ...rootStore.workOrderStore.workOrderSearch,
        paging: {
          ...rootStore.workOrderStore.workOrderSearch.paging,
          pageSize: parseInt(e.target.value),
          pageIndex: 1,
        },
      });
      setLoading(false);
    };
    //------------------------------------XXX----------------------------------------------------------

    // onchange value product search
    const handleChangeProductCode = async (
      e: React.SyntheticEvent<Element, Event>,
      value: ListStatusProduct | null
    ) => {
      if (value) {
        await rootStore.workOrderPresenter.setStateSearch(
          rootStore.workOrderStore,
          {
            ...rootStore.workOrderStore.workOrderSearch,
            productCode: value.key,
          }
        );
      } else {
        await rootStore.workOrderPresenter.setStateSearch(
          rootStore.workOrderStore,
          {
            ...rootStore.workOrderStore.workOrderSearch,
            productCode: "",
          }
        );
        await getDropdownProduct();
      }
    };

    // call info dua tren workOrderId der show data
    // change2 : gọi thẳng api để save barcode
    const handlePrintBarcode = async (id: string) => {
      setLoading(true);
      await rootStore.workOrderPresenter.saveBarcode(rootStore.workOrderStore, {
        workOrderId: id,
      });

      const result = rootStore.workOrderStore.saveBarcodeResponse.data;
      setLoading(false);
      if (rootStore.workOrderStore.saveBarcodeResponse.isSuccess) {
        toast.success(rootStore.workOrderStore.saveBarcodeResponse.message);
        setTransferData({
          batchId: result?.batchId,
          workOrderCardIds: result?.workOrderCardIds,
        });
        setTimeout(() => {
          // Form Post data submit in *form modal*
          ref.current?.submit();
        }, 100);
      } else {
        toast.error(rootStore.workOrderStore.saveBarcodeResponse.message);
      }
    };

    // Lấy keyWord ProductCode
    const handleChangeKeyWordProductCode = async (key: string) => {
      await getDropdownProduct(key);
    };

    const handleResetModal = () => {
      setInfoBarcode({
        workOderCode: "",
        productName: "",
        quantityPrinted: 0,
        quantity: 0,
      });
      setOpen(false);
    };

    const handleChangeStatus = (event: SelectChangeEvent) => {
      rootStore.workOrderPresenter.setStateSearch(rootStore.workOrderStore, {
        ...rootStore.workOrderStore.workOrderSearch,
        isUpdateMolde: JSON.parse(event.target.value),
      });
    };
    const handleChangePrintStatus = (event: SelectChangeEvent) => {
      rootStore.workOrderPresenter.setStateSearch(rootStore.workOrderStore, {
        ...rootStore.workOrderStore.workOrderSearch,
        printStatus: event.target.value || undefined,
      });
    };
    const onSaveBarcode = async (data: saveBarcodeModel) => {
      await rootStore.workOrderPresenter.saveBarcode(rootStore.workOrderStore, {
        workOrderId: WorkOrderId,
        printQuantity: data.printQuantity,
        quantityByPallet: data.quantityByPallet,
      });
      const result = rootStore.workOrderStore.saveBarcodeResponse.data;

      if (rootStore.workOrderStore.saveBarcodeResponse.isSuccess) {
        toast.success(rootStore.workOrderStore.saveBarcodeResponse.message);
        setTransferData({
          batchId: result?.batchId,
          workOrderCardIds: result?.workOrderCardIds,
        });
        setTimeout(() => {
          ref.current?.submit();
        }, 100);
      } else {
        toast.error(rootStore.workOrderStore.saveBarcodeResponse.message);
      }
    };

    // Xử lý tìm kiếm
    const onSearch = async (data: WorkOrderDetail) => {
      setLoading(true);
      await rootStore.workOrderPresenter.setStateSearch(
        rootStore.workOrderStore,
        {
          ...rootStore.workOrderStore.workOrderSearch,
          paging: {
            ...rootStore.workOrderStore.workOrderSearch.paging,
            pageIndex: 1,
          },
        }
      );
      await getListWorkOrder(rootStore.workOrderStore.workOrderSearch);
      setLoading(false);
    };

    const handleChangeDate = async (
      e: React.SyntheticEvent<Element, Event>,
      value: ListDate | null
    ) => {
      getEstimateFromDate(value?.key || "");
    };

    const handleChangeDocumentDate = async (
      e: React.SyntheticEvent<Element, Event>,
      value: ListDate | null
    ) => {
      getDocumentDate(value?.key || "");
    };
    const handleChangeMes = (
      event: React.SyntheticEvent<Element, Event>,
      newValue: ListStatusProduct | null,
      reason: AutocompleteChangeReason
    ) => {
      rootStore.workOrderPresenter.setStateSearch(rootStore.workOrderStore, {
        ...rootStore.workOrderStore.workOrderSearch,
        productionStatusCode: newValue?.key || undefined,
      });
    };
    //=====================================XXX===================XXX=================================================

    const [isLoading, setIsLoading] = useState(false);

    const [modalOpen, setModalOpen] = useState(false);

    const [valueDes, setValueDes] = useState('')
    const [radioCheck, setRadioCheck] = useState('VS')
    const [stepCodeValue, setStepCodeValue] = useState('')

    const [isCreate, setIsCreate] = useState(false);


    const handleCallAPICreateLSX = async () => {
      setIsLoading(true)
      console.log({
        description: valueDes,
        workOrderType: radioCheck,
        stepCode: radioCheck === 'VS' ? undefined : stepCodeValue
      });

      await rootStore.workOrderPresenter.createWOVS(rootStore.workOrderStore, {
        description: valueDes,
        workOrderType: radioCheck,
        stepCode: radioCheck === 'VS' ? undefined : stepCodeValue
      })
      if (rootStore.workOrderStore.createWOVS.isSuccess) {
        // call lại danh sách Table
        getListWorkOrder()
        message.success(rootStore.workOrderStore.createWOVS.message)
        setValueDes('')
        setStepCodeValue('')
        setRadioCheck('VS')
        setModalOpen(false)
      }
      setIsLoading(false)
    }

    const pagePermissions = () => {
      // Kiểm tra đường dẫn
      // check phân quyền bằng đường dẫn
      // kiểm tra url của web để tìm page id => dùng page id để tìm quyền của trang
      const path = window.location.pathname;
      const user = getUserSession() as User;
      const filteredData = user.webPermission.pageModel.filter((item) => {
        const itemNames = item.pageUrl.split(' ');
        return itemNames.some((name) => path.includes(name));
      });
      if (filteredData.length) {
        const permission = user.webPermission.pagePermissionModel.filter(
          (item) => item.pageId === filteredData[0].pageId,
        );
        if (permission.length) {
          if (permission.findIndex((item) => item.functionId === 'CREATE') > -1) {
            setIsCreate(true);
          }
        }
      }
    };


    return isReady ? (
      <div className="w-full py-3 px-5">
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-md font-bold text-gray-800 uppercase">
            Lệnh Sản Xuất
          </h3>

          {isCreate && (
            <CustomButton
              size="middle"
              loading={isLoading}
              onClick={async () => {
                setModalOpen(true)
              }}
              className="bg-primary"
              type="primary"
            >
              <span className="block">Tạo LSX</span>
            </CustomButton>
          )}
        </div>

        {/* Form nhập tìm kiếm */}
        <div className="w-full bg-white p-3.5 flex rounded mb-2 border border-neutral-300">
          <form className="w-full lg:grid lg:grid-cols-2 flex flex-col gap-2">
            {/* TP/BTP */}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 text-left sm:text-right">
                TP/BTP
              </label>
              {/* <input
                {...register('productCode')}
                type='text'
                className='col-span-2 text-gray-700 border border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600'
              /> */}
              <Autocomplete
                className="col-span-2 text-gray-700 text-default hover:ring-0 hover:outline-none hover:border-border_input !rounded-none border-border_input sm:ml-5 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                id="disabled-options-demo"
                options={dropdownProduct}
                onChange={handleChangeProductCode}
                value={dropdownProduct.find(
                  (value) =>
                    value.key ===
                    rootStore.workOrderStore.workOrderSearch.productCode
                )}
                sx={Style}
                classes={{
                  listbox: "text-default",
                  input: "!text-gray-700",
                  noOptions: "text-default",
                }}
                filterOptions={(options, state) => options}
                getOptionLabel={(option) => option.value}
                renderInput={(params) => (
                  <TextField
                    onChange={(e) =>
                      handleChangeKeyWordProductCode(e.target.value)
                    }
                    {...params}
                  />
                )}
              />
            </div>
            {/* Lệnh Sản Xuất */}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 text-left sm:text-right">
                Lệnh Sản Xuất
              </label>
              <input
                {...register("workOrderCode")}
                value={rootStore.workOrderStore.workOrderSearch.workOrderCode}
                onChange={(e) => {
                  // setDataSearch({
                  //   ...dataSearch,
                  //   workOrderCode: e.target.value,
                  // });
                  rootStore.workOrderPresenter.setStateSearch(
                    rootStore.workOrderStore,
                    {
                      ...rootStore.workOrderStore.workOrderSearch,
                      workOrderCode: e.target.value,
                    }
                  );
                }}
                type="text"
                className="col-span-2 text-gray-700 border border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* Trạng thái */}
            <div className="w-full sm:flex-row   sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 text-left sm:text-right">
                Trạng thái Netsuite
              </label>
              <FormControl className="col-span-2">
                <Select
                  {...register("printStatus")}
                  className=" text-gray-700 hover:ring-0 hover:outline-none hover:border-gray-300 !rounded-none border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  value={rootStore.workOrderStore.workOrderSearch.printStatus}
                  onChange={handleChangePrintStatus}
                  displayEmpty
                  sx={{
                    height: 35,
                  }}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value="">
                    <span className="text-default">-- Tất cả --</span>
                  </MenuItem>
                  {netsuiteStatus.map((item, index) => {
                    return (
                      <MenuItem key={index} value={item.key}>
                        <span className="text-default">{item.value}</span>
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="null"></div>
            {/* Trạng thái MES */}
            <div className="w-full sm:flex-row   sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 text-left sm:text-right">
                Trạng thái MES
              </label>
              <Autocomplete
                className="col-span-2 text-gray-700 p-0 hover:ring-0 hover:outline-none hover:border-gray-300 !rounded-none border-border_input sm:ml-5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                options={optionMes}
                onKeyPress={(e) => {
                  e.preventDefault();
                }}
                sx={Style}
                classes={{
                  listbox: "text-default",
                  input: "!text-gray-700 !px-6",
                  noOptions: "text-default",
                }}
                // value={valueMes}
                value={optionMes.find(
                  (value) =>
                    value.key ===
                    rootStore.workOrderStore.workOrderSearch
                      .productionStatusCode
                )}
                // onKeyDown khi nhấn nút Backspace không cho xóa
                onKeyDown={(event: any) => {
                  if (event.key === "Backspace") {
                    event.preventDefault();
                  }
                }}
                onChange={handleChangeMes}
                isOptionEqualToValue={(option, value) =>
                  option.key === value.key
                }
                // disableClearable={value !== null}// disable close button but value not be undefined
                id="controllable-states-demo"
                // getOptionDisabled={(option)=>option === optionMes[1]}// disable option
                getOptionLabel={(option) => option.value}
                renderInput={(params) => <TextField {...params} />}
              />
            </div>
            {/* can cap nhat so Serial*/}
            <div className="w-full sm:flex-row  sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 text-left sm:text-right">
                Cần thêm số serial
              </label>
              <FormControl className="col-span-2">
                <Select
                  {...register("isUpdateMolde")}
                  className=" text-gray-700 hover:ring-0 hover:outline-none hover:border-gray-300 !rounded-none border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  value={`${rootStore.workOrderStore.workOrderSearch.isUpdateMolde}`}
                  onChange={handleChangeStatus}
                  displayEmpty
                  sx={{ height: 35 }}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value="null">
                    <span className="text-default">-- Tất cả --</span>
                  </MenuItem>
                  <MenuItem className="text-default" value="true">
                    <span className="text-default">Thêm serial</span>
                  </MenuItem>
                  <MenuItem value="false">
                    <span className="text-default">Cập nhật serial</span>
                  </MenuItem>
                </Select>
              </FormControl>
            </div>

            {/* Ngày bắt đầu sản xuất dự kiến */}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 text-left sm:text-right">
                Ngày bắt đầu sx dự kiến
              </label>
              <Autocomplete
                className="col-span-2 text-gray-700 p-0 hover:ring-0 hover:outline-none hover:border-gray-300 !rounded-none border-border_input sm:ml-5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                id="disabled-options-demo"
                options={listDate}
                value={listDate.find(
                  (d) =>
                    d.key ===
                    rootStore.workOrderStore.workOrderSearch.estimateDate
                )}
                sx={Style}
                classes={{
                  listbox: "text-default",
                  input: "!text-gray-700",
                  noOptions: "text-default",
                }}
                onChange={handleChangeDate}
                isOptionEqualToValue={(option, value) =>
                  option.key === value.key
                }
                getOptionLabel={(option) => option.value}
                renderInput={(params) => <TextField {...params} />}
              />
            </div>

            {/* từ ngày */}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1 col-start-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 text-left sm:text-right">
                Từ ngày
              </label>
              <input
                {...register("estimateFromDateFrom")}
                type="date"
                disabled={
                  rootStore.workOrderStore.workOrderSearch.estimateDate !==
                  "Custom" &&
                  rootStore.workOrderStore.workOrderSearch.estimateDate !== ""
                }
                value={
                  rootStore.workOrderStore.workOrderSearch
                    .estimateFromDateFrom || ""
                }
                onChange={async (e) =>
                  await rootStore.workOrderPresenter.setStateSearch(
                    rootStore.workOrderStore,
                    {
                      ...rootStore.workOrderStore.workOrderSearch,
                      estimateFromDateFrom: e.target.value || undefined,
                    }
                  )
                }
                className="col-span-2 text-gray-700 border border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* đến ngày */}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 text-left sm:text-right">
                Đến ngày
              </label>
              <input
                {...register("estimateFromDateTo")}
                type="date"
                disabled={
                  rootStore.workOrderStore.workOrderSearch.estimateDate !==
                  "Custom" &&
                  rootStore.workOrderStore.workOrderSearch.estimateDate !== ""
                }
                value={
                  rootStore.workOrderStore.workOrderSearch.estimateFromDateTo ||
                  ""
                }
                onChange={async (e) =>
                  await rootStore.workOrderPresenter.setStateSearch(
                    rootStore.workOrderStore,
                    {
                      ...rootStore.workOrderStore.workOrderSearch,
                      estimateFromDateTo: e.target.value || undefined,
                    }
                  )
                }
                className="col-span-2 text-gray-700 border border-border_input sm:ml-5 px-3 py-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* Search ngày phát lệnh */}
            {/* Ngày bắt đầu sản xuất dự kiến */}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 text-left sm:text-right">
                Ngày ban hành LSX
              </label>
              <Autocomplete
                className="col-span-2 text-gray-700 p-0 hover:ring-0 hover:outline-none hover:border-gray-300 !rounded-none border-border_input sm:ml-5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                id="disabled-options-demo"
                options={listDate}
                // dataSearch.documentDate từ store khi mới vào là {key:'',value:''} = a
                // currentDocumentDate đã được set khi mới vào là {key:'ThisWeek',value:'ThisWeek|Tuần này} = b
                // khí a đúng thì lấy giá trị b , a sai thì lấy c mục định để set value khi mới vào

                value={listDate.find(
                  (d) =>
                    d.key ===
                    rootStore.workOrderStore.workOrderSearch.documentDate
                )}
                sx={Style}
                classes={{
                  listbox: "text-default",
                  input: "!text-gray-700",
                  noOptions: "text-default",
                }}
                onChange={handleChangeDocumentDate}
                // check value
                // isOptionEqualToValue={(option, value) => option.key === value.key}
                getOptionLabel={(option) => option.value}
                renderInput={(params) => <TextField {...params} />}
              />
            </div>
            {/*  */}
            <div></div>
            {/* từ ngày */}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 text-left sm:text-right">
                Từ ngày
              </label>
              <input
                {...register("documentDateFrom")}
                type="date"
                disabled={
                  rootStore.workOrderStore.workOrderSearch.documentDate !==
                  "Custom" &&
                  rootStore.workOrderStore.workOrderSearch.documentDate !== ""
                }
                value={
                  rootStore.workOrderStore.workOrderSearch.documentDateFrom ||
                  ""
                }
                onChange={async (e) =>
                  await rootStore.workOrderPresenter.setStateSearch(
                    rootStore.workOrderStore,
                    {
                      ...rootStore.workOrderStore.workOrderSearch,
                      documentDateFrom: e.target.value || undefined,
                    }
                  )
                }
                className="col-span-2 text-gray-700 border border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* đến ngày */}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 text-left sm:text-right">
                Đến ngày
              </label>
              <input
                {...register("documentDateTo")}
                type="date"
                // disabled={dataSearch.documentDate?.key !== 'Custom' && dataSearch.documentDate?.key !== ''}
                disabled={
                  rootStore.workOrderStore.workOrderSearch.documentDate !==
                  "Custom" &&
                  rootStore.workOrderStore.workOrderSearch.documentDate !== ""
                }
                // value={dataSearch.documentDateTo || ''}
                value={
                  rootStore.workOrderStore.workOrderSearch.documentDateTo || ""
                }
                onChange={async (e) =>
                  await rootStore.workOrderPresenter.setStateSearch(
                    rootStore.workOrderStore,
                    {
                      ...rootStore.workOrderStore.workOrderSearch,
                      documentDateTo: e.target.value || undefined,
                    }
                  )
                }
                className="col-span-2 text-gray-700 border border-border_input sm:ml-5 px-3 py-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* button tìm kiếm */}
            <div className="w-full flex justify-center col-span-2">
              <button
                type="submit"
                onClick={handleSubmit(onSearch)}
                className={`flex items-center text-white bg-blue-700 rounded text-default px-2.5 py-1 mt-1 text-center focus:outline-none hover:bg-blue-600 ${loading && "bg-blue-400"
                  }`}
              >
                {loading ? (
                  <>
                    <TbLoaderQuarter className="animate-spin bg" />
                    Loading...
                  </>
                ) : (
                  <>
                    <HiSearch className="font-bold text-lg" />
                    Tìm kiếm
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
        {/* Table work order */}
        <div className="w-full bg-white py-3 px-5 rounded border border-neutral-300">
          {/*=========== Pagination =======================*/}
          <Pagination
            pageCount={
              rootStore.workOrderStore.workOrder.paging?.totalPage || 0
            }
            // forcePage={pageIndex - 1}
            forcePage={
              rootStore.workOrderStore.workOrderSearch.paging.pageIndex - 1
            }
            onPageSizeChange={handleChangePageSize}
            onPageChange={handleChangePageIndex}
          />

          {/* =========== Table Work Order ===============*/}
          <div className={`overflow-x-auto mt-3 `}>
            <TableContainer
              component={Paper}
              className="w-full table-auto space-collapse mb-5 text-default !overflow-y-auto !max-h-[500px]"
            >
              <Table aria-label="simple table" sx={Style.borderInherit}>
                <TableHead className="font-medium text-gray-700 text-default bg-gray-100 !z-10 !sticky !top-0">
                  <TableRow>
                    {column?.map((item, index) => {
                      if (item.visible) {
                        return (
                          <TableCell
                            sx={[Style.MuiTableCellRoot]}
                            key={index}
                            align={`${item.align === "text-center"
                              ? "center"
                              : "inherit"
                              }`}
                            onClick={
                              item.isSoft
                                ? () => {
                                  handleSortRequest(item.key);
                                }
                                : () => { }
                            }
                            scope="col"
                            className={`${item.visible ? "" : "hidden"}
                          ${item.sticky} ${item.width}
                           py-2 px-2 border text-left bg-primary ${item.align}`}
                          >
                            {item.isSoft ? (
                              <div className="flex gap-1 items-center cursor-pointer">
                                <span>{`${item.columnName}`}</span>
                                <span>
                                  {rootStore.workOrderStore.workOrderSearch
                                    .paging.orderBy === item.key ? (
                                    <FaSortDown />
                                  ) : rootStore.workOrderStore.workOrderSearch
                                    .paging.orderByDesc === item.key ? (
                                    <FaSortUp />
                                  ) : (
                                    <FaSort />
                                  )}
                                </span>
                              </div>
                            ) : (
                              `${item.columnName}`
                            )}
                          </TableCell>
                        );
                      }
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listWorkOrder.length ? (
                    listWorkOrder?.map((row, index) => (
                      <TableRow key={row.stt}>
                        {/* Số thứ tự */}
                        <TableCell
                          align="center"
                          sx={[Style.MuiTableCellRootTd, Style.sticky1]}
                          className="border"
                        >
                          {row.stt}
                        </TableCell>
                        {/* chuc nang */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd, Style.sticky2]}
                          className="border whitespace-nowrap"
                        >
                          <div className="flex gap-2">
                            <button
                              onClick={() =>
                                handlePrintBarcode(row.workOrderId)
                              }
                              disabled={loading}
                              className=" text-default text-white bg-primary px-2.5 py-0.25 rounded-base border-gray-300 border flex gap-1 items-center justify-center"
                            >
                              <AiFillPrinter /> In thẻ treo
                            </button>
                            {/* cần cập nhật khuôn thì hiển thị nút thêm serial */}
                            {row.isUpdateMold && (
                              <button
                                onClick={() =>
                                  navigate(
                                    `Serial/WorkOrderId=${row.workOrderId}`
                                  )
                                }
                                className=" text-default  bg-btn_edit py-0.25 rounded-base px-2.5 border-gray-300 border flex gap-1 items-center justify-center flex-1"
                              >
                                Thêm Serial
                              </button>
                            )}
                            {row.isEdit && (
                              <button
                                onClick={() =>
                                  navigate(
                                    `Serial/WorkOrderId=${row.workOrderId}`
                                  )
                                }
                                className=" text-default  bg-btn_edit py-0.25 rounded-base px-2.5 border-gray-300 border flex gap-1 items-center justify-center flex-1"
                              >
                                Cập nhật Serial
                              </button>
                            )}
                          </div>
                        </TableCell>
                        {/* mã uu tien*/}
                        {/* <TableCell
                        sx={[Style.MuiTableCellRootTd, Style.sticky3]}
                        className='border whitespace-nowrap hidden'
                      >
                        {row.priority}
                      </TableCell> */}
                        {/* Lenh san xuat */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd, Style.sticky3]}
                          // onClick={() => navigate(`Detail/${row.workOrderId}`)}
                          align="center"
                          className="border whitespace-nowrap hover:text-sky-600 cursor-pointer"
                        >
                          <Link
                            to={`Detail/${row.workOrderId}`}
                            target="_blank"
                            className="text-blue-500"
                          >
                            {row.workOrderCode}
                          </Link>
                        </TableCell>
                        {/* Khách hàng  */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="left"
                          className="border whitespace-nowrap"
                        >
                          {row.customerName}
                        </TableCell>
                        {/* Loại lsx */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="center"
                          className="border whitespace-nowrap"
                        >
                          {row.workOrderType}
                        </TableCell>
                        {/* ma LSX tong hop */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="center"
                          className="border whitespace-nowrap"
                        >
                          {row.parentWorkOrderCode}
                        </TableCell>
                        {/*Lệnh ghép bài/Phiếu thiết kế */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="left"
                          className="border whitespace-nowrap"
                        >
                          {row.matchCardId ? (
                            <Link
                              className="text-blue-700"
                              target="_blank"
                              to={`/Work/MassWorkOrder/matchCardCommandId=${row.matchCardId}`}
                            >
                              {row.matchCard}
                            </Link>
                          ) : (
                            row.matchCard
                          )}
                        </TableCell>
                        {/* Ma TP/BTP */}
                        <TableCell
                          align="left"
                          sx={[Style.MuiTableCellRootTd]}
                          className="border whitespace-nowrap"
                        >
                          {row.productCode}
                        </TableCell>
                        {/* Ten TP/BTP */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="left"
                          className=" border"
                        >
                          <Tooltip title={row.productName}>
                            <div className="!w-72 clamp-1">
                              {row.productName}
                            </div>
                          </Tooltip>
                        </TableCell>
                        {/* Bom version */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="left"
                          className="border whitespace-nowrap "
                        >
                          {row.bomVersion}
                        </TableCell>
                        {/* So luong phat lenh*/}
                        <TableCell
                          align="right"
                          sx={[Style.MuiTableCellRootTd]}
                          className="border whitespace-nowrap"
                        >
                          {formatNumber(row.quantity, 0)}
                        </TableCell>
                        {/* don vi tinh */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="left"
                          className="border whitespace-nowrap"
                        >
                          {row.unit}
                        </TableCell>
                        {/* Ngày ban hành LSX */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="center"
                          className="border whitespace-nowrap"
                        >
                          <Moment format="DD/MM/YYYY HH:mm:ss">
                            {row.documentDate}
                          </Moment>
                        </TableCell>
                        {/* ngay bat dau SX du kien */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="center"
                          className="border whitespace-nowrap"
                        >
                          <Moment format="DD/MM/YYYY">
                            {row.estimateFromDate}
                          </Moment>
                        </TableCell>
                        {/* ngay ket thuc SX du kien  */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="center"
                          className="border whitespace-nowrap "
                        >
                          <Moment format="DD/MM/YYYY">
                            {row.estimateToDate}
                          </Moment>
                        </TableCell>
                        {/* ngay bat dau sx thuc te  */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="center"
                          className="border whitespace-nowrap"
                        >
                          {row.actualStartDate ? (
                            <Moment format="DD/MM/YYYY HH:mm">
                              {row.actualStartDate}
                            </Moment>
                          ) : (
                            ""
                          )}
                        </TableCell>
                        {/* ngay ket thuc sx thuc te  */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="center"
                          className="border whitespace-nowrap"
                        >
                          {row.actualEndDate ? (
                            <Moment format="DD/MM/YYYY HH:mm">
                              {row.actualEndDate}
                            </Moment>
                          ) : (
                            ""
                          )}
                        </TableCell>

                        {/* Hạng mục in  */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="left"
                          className="border"
                        >
                          <Tooltip title={row.printItem}>
                            <div className="!w-72 clamp-1">{row.printItem}</div>
                          </Tooltip>
                        </TableCell>
                        {/* Tên routing  */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="left"
                          className="border whitespace-nowrap"
                        >
                          {row.routingName}
                        </TableCell>

                        {/*Kiểu in  */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="left"
                          className="border whitespace-nowrap"
                        >
                          {row.printStyle}
                        </TableCell>
                        {/*  Ngày yêu cầu hàng in về */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="center"
                          className="border whitespace-nowrap"
                        >
                          {row.printReqDate ? (
                            <Moment format="DD/MM/YYYY HH:mm:ss">
                              {row.printReqDate}
                            </Moment>
                          ) : (
                            ""
                          )}
                        </TableCell>
                        {/* Ngày yêu cầu nhập kho*/}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="center"
                          className="border whitespace-nowrap"
                        >
                          {row.deliveryDate ? (
                            <Moment format="DD/MM/YYYY">
                              {row.deliveryDate}
                            </Moment>
                          ) : (
                            ""
                          )}
                        </TableCell>
                        {/*Công ty gia công in */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="left"
                          className="border whitespace-nowrap"
                        >
                          {row.printCompany}
                        </TableCell>

                        {/* Đơn vị gia công thành phẩm */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="left"
                          className="border whitespace-nowrap"
                        >
                          {row.processingUnit}
                        </TableCell>
                        {/*  Ghi chú sản xuất */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="left"
                          className="border"
                        >
                          <Tooltip title={row.attachedNote}>
                            <div className="!w-60 clamp-1">
                              {row.attachedNote}
                            </div>
                          </Tooltip>
                        </TableCell>
                        {/*  Tình trạng sản phẩm */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="left"
                          className="border whitespace-nowrap"
                        >
                          {row.productStatus}
                        </TableCell>

                        {/* so PO/hop dong/bao gia  */}
                        <TableCell
                          sx={[Style.MuiTableCellRootTd]}
                          align="left"
                          className="border whitespace-nowrap"
                        >
                          {row.poCode}
                        </TableCell>
                        {/* Khuôn */}
                        <TableCell
                          align="left"
                          sx={[Style.MuiTableCellRootTd]}
                          className="border"
                        >
                          <Tooltip
                            title={row.molds
                              .map((item) => {
                                return `${item.moldCode} ${item.serial !== null
                                  ? "- (" + item.serial + ")"
                                  : ""
                                  }`;
                              })
                              .join(" / ")}
                          >
                            <div className="!w-72 clamp-1">
                              {row.molds
                                .map((item) => {
                                  return `${item.moldCode} ${item.serial !== null
                                    ? "- (" + item.serial + ")"
                                    : ""
                                    }`;
                                })
                                .join(" / ")}
                            </div>
                          </Tooltip>
                        </TableCell>
                        {/* trang thai print status (Trạng thái Netsuite) */}
                        <TableCell
                          align="left"
                          sx={[Style.MuiTableCellRootTd]}
                          className="border whitespace-nowrap"
                        >
                          {row.printStatus}
                        </TableCell>
                        {/* Trạng thái MES */}
                        <TableCell
                          align="left"
                          sx={[Style.MuiTableCellRootTd]}
                          className="border whitespace-nowrap"
                        >
                          {row.statusMES}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={100}
                        sx={[Style.MuiTableCellRootTd]}
                        align="center"
                        className="border whitespace-nowrap"
                      >
                        Không tìm thấy dòng nào phù hợp
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          {/* form modal */}
          <div
            className={`w-full h-screen fixed bg-modal inset-0 z-[100] ${!open && "hidden"
              }`}
          >
            <div className="fixed min-w-[400px] bg-white top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 shadow-xl shadow-modal text-default rounded border-t-2 border-t-sky-700">
              <div className="bg-blue-600 flex justify-between items-center px-4">
                <div></div>
                <h2 className="text-[20px] font-medium text-white py-2">
                  In thẻ treo pallet
                </h2>
                <button onClick={handleResetModal}>
                  <MdClose className="text-[25px] text-white hover:text-white hover:bg-red-400 hover:p-[2px]" />
                </button>
              </div>
              {/* Form Post data */}
              <form
                ref={ref}
                method="POST"
                action={`${URL_PRINT}Reports/ReportWorkOrderCard/Index/${transferData?.batchId}`}
                target={"_blank"}
                className="px-4 pb-2 pt-4 text-default"
              >
                <div className="w-full sm:flex-row mb-1 sm:items-center grid grid-cols-2 ">
                  <label className="min-w-[150px] font-medium text-gray-700 sm:text-start">
                    Lệnh sản xuất:
                  </label>
                  <div className="col-span-1/3 text-gray-700">
                    {infoBarcode.workOderCode}
                  </div>
                </div>
                <div className="w-full sm:flex-row mb-3 sm:items-center grid grid-cols-2">
                  <label className="min-w-[150px] font-medium text-gray-700 sm:text-start">
                    TP/BTP:{" "}
                  </label>
                  <div className="col-span-1 text-gray-700">
                    {infoBarcode.productName}
                  </div>
                </div>
                <div className="w-full sm:flex-row mb-3 sm:items-center grid grid-cols-2 ">
                  <label className="min-w-[150px] font-medium text-gray-700 sm:text-start">
                    Số lượng sản xuất:
                  </label>
                  <div className="col-span-1 text-gray-700">
                    {formatNumber(infoBarcode.quantity, 0)}
                  </div>
                </div>
                <div className="w-full sm:flex-row mb-3 sm:items-center grid grid-cols-2 ">
                  <label className="min-w-[150px] font-medium text-gray-700 sm:text-start">
                    Số lượng đã in:
                  </label>
                  <div className="col-span-1 text-gray-700">
                    {formatNumber(infoBarcode.quantityPrinted, 0)}
                  </div>
                </div>
                <div className="w-full sm:flex-row mb-3 sm:items-center grid grid-cols-2 ">
                  {/* thông báo lỗi khi userName không hợp lệ */}
                  <label className="min-w-[150px] font-medium text-gray-700 sm:text-start">
                    Số lượng thẻ treo cần in thêm:
                  </label>
                  <input
                    {...registerForm2("printQuantity")}
                    onChange={(e) => {
                      setValuePrintQuantity(e.target.value);
                    }}
                    value={valuePrintQuantity}
                    className={`col-span-1 text-gray-700 border px-3 py-1.5 text-default flex-1 focus-visible:outline-none ${Number(valuePrintQuantity) > 100
                      ? "border-red-600"
                      : "border-gray-300  focus:border-blue-500 caret-blue-600"
                      }  `}
                    type="text"
                  />
                  {Number(valuePrintQuantity) > 100 && (
                    <p className="mt-2 col-start-2 col-span-2 text-xs text-red-500">
                      vui lòng nhập nhỏ hơn 100
                    </p>
                  )}

                  <input name="printCode" type="text" className="sr-only" />
                </div>
                <div className="w-full sm:flex-row mb-3 sm:items-center grid grid-cols-2 ">
                  <label className="min-w-[150px] font-medium text-gray-700 sm:text-start">
                    Số lượng SP trên thẻ treo
                  </label>
                  <input
                    {...registerForm2("quantityByPallet")}
                    className="col-span-1 text-gray-700 border border-gray-300  px-3 py-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                    type="text"
                  />
                </div>
                <div className="flex justify-between mt-3  p-4">
                  <button
                    type="button"
                    onClick={handleResetModal}
                    className="rounded-sm bg-gray-200 hover:bg-gray-400/90 px-3 py-1 min-w-[80px]"
                  >
                    Đóng
                  </button>
                  <button
                    type="button"
                    disabled={
                      rootStore.workOrderStore.saveBarcodeResponse.isSuccess
                    }
                    onClick={handleSubmitBarcode(onSaveBarcode)}
                    className={`rounded-sm bg-primary hover:bg-primary/90 px-3 py-1 min-w-[80px] text-white disabled:bg-gray-400 ${loading && "!bg-primary/90"
                      }`}
                  >
                    In phiếu
                  </button>
                </div>
              </form>
            </div>
          </div>
          <span className="block text-default">
            Đang xem từ {`${listWorkOrder && listWorkOrder.length ? listWorkOrder[0]?.stt : 0}`} đến {`${listWorkOrder && listWorkOrder.length ? listWorkOrder[listWorkOrder.length - 1]?.stt : 0}`} trong tổng số{' '}
            {`${rootStore.workOrderStore.workOrder.paging?.totalCount || 0}`} mục
          </span>
        </div>


        <Modal
          title="TẠO LỆNH SẢN XUẤT"
          centered
          open={modalOpen}
          // okButtonProps={{
          //   style: {
          //     display: 'none'
          //   }
          // }}
          cancelButtonProps={{
            style: {
              display: 'none'
            }
          }}
          style={{
          }}
          okText={"Tạo"}
          onOk={() => {
            if (valueDes) {
              handleCallAPICreateLSX()
              setModalOpen(false)
            } else if (radioCheck === 'LK' && !stepCodeValue) {
              message.warning('Vui lòng chọn công đoạn');
            } else if (!valueDes) {
              message.warning('Vui lòng nhập ghi chú sản xuất');
            }
          }
          }
          onCancel={() => {
            setModalOpen(false)
            setStepCodeValue('')
            setRadioCheck('VS')
            setValueDes('')
          }}
        >
          <ModalCreateDes
            modalOpen={modalOpen}
            stepCodeValue={stepCodeValue}
            setStepCodeValue={setStepCodeValue}
            radioCheck={radioCheck}
            setRadioCheck={setRadioCheck}

            valueDes={valueDes} setValueDes={setValueDes} />
        </Modal>
      </div>
    ) : (
      <LoadingScreen></LoadingScreen>
    );



  });
}
